import { ApiCreateCancerReport } from "./participant";

export enum TaskName {
  cancer = "cancer",
  revocation = "revocation",
  biospecimen = "biospecimen",
  tissue = "tissue",
}

export enum TaskStatus {
  unStarted = "unstarted",
  inProgress = "in_progress",
  deferred = "later",
  completed = "complete",
  ignored = "ignored",
}

type Task = {
  id: number;
  name: TaskName;
  status: TaskStatus;
  participantId: string;
  timestamp: string;
};

export type CancerTask = Task & {
  name: TaskName.cancer;
  data: {
    cancerType?: string;
    otherCancerType?: string;
    bloodCancerType?: string;
    breastSide?: string;
    cancerDate?: string;
    markedComplete?: {
      source: string;
      timestamp: string;
    };
    reportedCancer: ApiCreateCancerReport;
  };
};

export type ApiTasksResponseType<TaskType extends ApiManagementTask> = {
  data: TaskType[];
  totalItems: number;
};

export interface TasksOutletContext {
  openCancerTaskCount: number;
  openRevocationTaskCount: number;
}

export type BiospecimenTask = Task & {
  name: TaskName.biospecimen;
  data: {
    participantName: string;
    study: string;
    method: string;
    timestamp: string;
    note: string;
  };
};

export type RevocationType = "contact" | "refusal" | "revoke";
export const TASK_STATUS_MAP = {
  [TaskStatus.inProgress]: "acknowledged",
  [TaskStatus.deferred]: "snoozed",
  [TaskStatus.completed]: "completed",
  [TaskStatus.ignored]: "ignored",
};
export const REVOCATION_TYPE_MAP: Record<
  RevocationType,
  { typeLabel: string; typePastTense: string }
> = {
  contact: { typeLabel: "Contact", typePastTense: "Contact Requested" },
  refusal: { typeLabel: "Refusal", typePastTense: "Refused" },
  revoke: { typeLabel: "Revocation", typePastTense: "Revoked" },
};
export type RevocationTask = Task & {
  name: TaskName.revocation;
  data: {
    revocationType: RevocationType;
    refusalSignature?: string;
    revokeSignature?: string;
    acknowledged?: {
      source: string;
      timestamp: string;
    };
    markedComplete?: {
      source: string;
      timestamp: string;
    };
  };
};
export type EditRevocationTask = Partial<Pick<RevocationTask, "status" | "data">>;
export type EditBiospecimenTask = Partial<Pick<BiospecimenTask, "status" | "data">>;
export type EditCancerTask = Partial<Pick<CancerTask, "status" | "data">>;

export type ApiManagementTask = RevocationTask | CancerTask | BiospecimenTask;
